import { render, staticRenderFns } from "./verdictRender.vue?vue&type=template&id=3f6be362&scoped=true"
import script from "./verdictRender.vue?vue&type=script&lang=js"
export * from "./verdictRender.vue?vue&type=script&lang=js"
import style0 from "./verdictRender.vue?vue&type=style&index=0&id=3f6be362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6be362",
  null
  
)

export default component.exports